import { FormEvent, useState } from 'react';
import { Bug, X } from 'lucide-react';

export default function BugReportWidget() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [steps, setSteps] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const subject = encodeURIComponent(`ClimbWriter bug: ${title.trim() || 'Report'}`);
    const body = encodeURIComponent(`${description.trim()}\n\nSteps to reproduce:\n${steps.trim() || 'Not provided'}\n\nPage: ${window.location.href}\nBrowser: ${navigator.userAgent}`);
    window.location.href = `mailto:info@novelsprint.com?subject=${subject}&body=${body}`;
    setOpen(false);
  };

  return <>
    <button className="cw-bug-trigger" type="button" onClick={() => setOpen(true)} aria-label="Report a bug"><span>Report bug</span><Bug size={18}/></button>
    {open && <div className="cw-bug-overlay" onMouseDown={event => { if (event.target === event.currentTarget) setOpen(false); }}>
      <form className="cw-bug-dialog" onSubmit={submit} role="dialog" aria-modal="true" aria-labelledby="cw-bug-title">
        <header><div><h2 id="cw-bug-title">Report a bug</h2><p>Tell us what went wrong. Page and browser details are added automatically.</p></div><button type="button" onClick={() => setOpen(false)} aria-label="Close bug report"><X size={19}/></button></header>
        <label>Short title <span>optional</span><input value={title} onChange={event => setTitle(event.target.value)} maxLength={120}/></label>
        <label>What happened?<textarea required value={description} onChange={event => setDescription(event.target.value)} rows={5} maxLength={3000}/></label>
        <label>Steps to reproduce <span>optional</span><textarea value={steps} onChange={event => setSteps(event.target.value)} rows={3} maxLength={2500}/></label>
        <p className="cw-bug-note">Submitting opens your email app with the report prepared. Review it there before sending. See our <a href="/privacy">Privacy Policy</a>.</p>
        <footer><button type="button" onClick={() => setOpen(false)}>Cancel</button><button type="submit">Prepare report</button></footer>
      </form>
    </div>}
  </>;
}
